export interface ResponseObject {
  items: any;
  pageNumber: number;
  pageSize: number;
  resultCount: number;
  totalPages: number;
}
